import { EntityDefinition } from '@/types/crud';

export const contactEntity: EntityDefinition = {
  name: 'contacts',
  displayName: 'Contacts',
  displayNameSingular: 'Contact',
  apiEndpoint: '/generic/crm_contacts',
  idField: 'id',
  nameField: 'first_name',
  copyable: true,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'first_name',
      label: 'First Name',
      type: 'text',
      required: true,
      placeholder: 'Enter first name',
      order: 1
    },
    {
      key: 'last_name',
      label: 'Last Name',
      type: 'text',
      required: true,
      placeholder: 'Enter last name',
      order: 2
    },
    {
      key: 'email',
      label: 'Email',
      type: 'email',
      required: true,
      placeholder: 'Enter email address',
      order: 3
    },
    {
      key: 'phone',
      label: 'Phone',
      type: 'text',
      placeholder: 'Enter phone number',
      order: 4
    },
    {
      key: 'mobile',
      label: 'Mobile',
      type: 'text',
      placeholder: 'Enter mobile number',
      order: 5
    },
    {
      key: 'title',
      label: 'Title',
      type: 'text',
      placeholder: 'Enter job title',
      order: 6
    },
    {
      key: 'department',
      label: 'Department',
      type: 'text',
      placeholder: 'Enter department',
      order: 7
    },
    {
      key: 'company_name',
      label: 'Company',
      type: 'text',
      placeholder: 'Enter company name',
      order: 8
    },
    {
      key: 'linkedin_url',
      label: 'LinkedIn',
      type: 'url',
      placeholder: 'Enter LinkedIn URL',
      order: 9
    },
    {
      key: 'address',
      label: 'Address',
      type: 'text',
      placeholder: 'Enter address',
      order: 10
    },
    {
      key: 'city',
      label: 'City',
      type: 'text',
      placeholder: 'Enter city',
      order: 11
    },
    {
      key: 'state',
      label: 'State',
      type: 'text',
      placeholder: 'Enter state',
      order: 12
    },
    {
      key: 'country',
      label: 'Country',
      type: 'text',
      placeholder: 'Enter country',
      order: 13
    },
    {
      key: 'postal_code',
      label: 'Postal Code',
      type: 'text',
      placeholder: 'Enter postal code',
      order: 14
    },
    {
      key: 'lead_source',
      label: 'Lead Source',
      type: 'text',
      placeholder: 'Enter lead source',
      order: 15
    },
    {
      key: 'lead_score',
      label: 'Lead Score',
      type: 'number',
      placeholder: 'Enter lead score',
      order: 16
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      required: true,
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'prospect', label: 'Prospect' },
        { value: 'lead', label: 'Lead' },
        { value: 'customer', label: 'Customer' }
      ],
      defaultValue: 'prospect',
      order: 17
    },
    {
      key: 'notes',
      label: 'Notes',
      type: 'textarea',
      placeholder: 'Enter notes',
      order: 18
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      hidden: true,
      order: 19
    },
    {
      key: 'updated_at',
      label: 'Updated',
      type: 'datetime',
      hidden: true,
      order: 20
    }
  ],
  tableColumns: [
    {
      key: 'first_name',
      label: 'First Name',
      sortable: true
    },
    {
      key: 'last_name',
      label: 'Last Name',
      sortable: true
    },
    {
      key: 'email',
      label: 'Email',
      sortable: true
    },
    {
      key: 'phone',
      label: 'Phone',
      sortable: true
    },
    {
      key: 'title',
      label: 'Title',
      sortable: true
    },
    {
      key: 'company_name',
      label: 'Company',
      sortable: true
    },
    {
      key: 'status',
      label: 'Status',
      sortable: true,
      colorCoding: {
        'active': 'text-green-600 font-medium'
      }
    },
    {
      key: 'created_at',
      label: 'Created',
      sortable: true
    }
  ],
  searchFields: ['first_name', 'last_name', 'email', 'company_name', 'title'],
  defaultSort: { field: 'first_name', direction: 'asc' }
};
